import Vue, { PluginObject, VueConstructor } from 'vue'
import { $fetch } from '@/api/fetch';


class ReFetch implements PluginObject<void> {
    install(vue: VueConstructor) {
        vue.prototype.$fetch = $fetch;
    }
}

Vue.use(new ReFetch);